const minimumPasswordLength = 7;
const roles = ["user", "admin", "dev"];

export { minimumPasswordLength, roles };
